// extracted by mini-css-extract-plugin
export default {"products_caption":"Caption_products_caption__kKGjP","hr":"Caption_hr__yBzY8"};